import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.09 16.85"><title>SiteIcons</title><path d="M15.26,8a.83.83,0,0,0-.83.83,6.4,6.4,0,1,1-2.74-5.24H10.16a.83.83,0,1,0,0,1.66h3.6l.12,0,.14,0a.8.8,0,0,0,.18-.09l.08,0,0,0a.81.81,0,0,0,.12-.14.8.8,0,0,0,.08-.11.81.81,0,0,0,.05-.15.81.81,0,0,0,0-.16s0,0,0,0V.83a.83.83,0,1,0-1.66,0V2.42A8,8,0,1,0,16.09,8.8.83.83,0,0,0,15.26,8Z"/></svg>
)